
const connectionsapi = (state = [], action) => {
  switch (action.type) {
    case 'CONNECTIONAPI':
    return {
        ...state,
        type: "CONNECTIONAPI",
        imsdn: action.imsdn,
        db: action.db,
        sip: action.sip,
        mensagem: action.mensagem,
      }
    case "REF_IFRAME_INGDESK":
        return { ...state, iframe_ref: action.iframe_ref};
    default:
    return state
  }
}

export default connectionsapi